import React from "react";
import { Container } from "react-bootstrap";

import { TUserType } from "../../types/forms";
import { redirect, useLoaderData } from "react-router";
import RegisterCoach from "./RegisterCoach";
import { getAgeLevels } from "../../lib/api";
import { IAPIResponse, IAgeLevel } from "../../types/api";

export const loader = async ({ params }: any) => {
    if (
        !params?.userType ||
        !(["coach"] as TUserType[]).includes(params.userType)
    ) {
        return redirect("/");
    }

    switch (params.userType) {
        case "coach":
            return {
                ageLevels: await getAgeLevels(),
                userType: params.userType,
            };
    }
};

const Register = (): React.JSX.Element => {
    const { userType, ageLevels } = useLoaderData() as {
        userType: TUserType;
        ageLevels?: IAPIResponse & {
            ageLevels: IAgeLevel[];
        };
    };

    const renderForm = (userType: TUserType): React.JSX.Element => {
        switch (userType) {
            case "coach":
                return (
                    <RegisterCoach
                        ageLevels={ageLevels?.ageLevels as IAgeLevel[]}
                    />
                );
        }
    };
    return (
        <div data-testid="registerContent">
            <Container className="py-5 register">
                {renderForm(userType)}
            </Container>
        </div>
    );
};

export default Register;
